module.exports = __webpack_public_path__ + "img/footerbackgrounddark.67086fb7.webp";